<template>
    <div class="navbar clearfix" >
        <el-breadcrumb class="breadcrumb-container" separator-class="el-icon-arrow-right">
            <el-breadcrumb-item v-for="item in levelList" :key="item.path" :to="item.path"><span style="color:white">{{item.meta.title}}</span></el-breadcrumb-item>
        </el-breadcrumb>
    </div>
</template>
 
<script>
    export default {
        name: 'Navbar',
        data() {
            return {
                levelList: []
            }
        },
        watch: {
            $route() {
                this.getBreadcrumb()
            }
        },
        created(){
            this.getBreadcrumb()
        },
        methods:{
            getBreadcrumb() {
                //$route.matched一个数组 包含当前路由的所有嵌套路径片段的路由记录
                let matched = this.$route.matched.filter(item => item.name)
                const first = matched[1];
                if (first&&first.name.trim().toLocaleLowerCase() != 'container'.toLocaleLowerCase()) {
                    matched = [{ path: '/home', meta: { title: '首页' }}].concat({ path: '', meta: { title:first.name}})
                }
                this.levelList = matched
            }
        }
    }
</script>

<style lang="scss">
   .el-icon-arrow-right font1{
       color:white
   }
</style>


// WEBPACK FOOTER //
// src/components/navbar.vue